import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import { MDBDataTable } from 'mdbreact';
import {
  Link
} from "react-router-dom";
import { BallClipRotate } from 'react-pure-loaders';

class Dashboard extends Component {

  constructor(props) {
    super(props)

    this.state = {
      manageaccounts: [],
      manageaccountsForApproval: [],
      errorMsg: '',

      clientID: '',
      payeeEmail: '',
      payeeName: '',
      entityName: '',
      requestID: '',
      nickname:'',
      requestID: '',
      paymentData: [],
      showModal: false,
      loading: true,
    }
  }

  //   componentWillUpdate(nextProps, nextState) {
  //   console.log('componentWillReceiveProps ',nextProps , nextState );  
  //  // alert(nextProps.location.state.payeeEmail);

  // }

  hideModal = () => {
    this.setState({ showModal: false })
  }

  LoadRecentPayments(params) {
    debugger;
    // Authentication using Auth Code - AON Start
   const AuthStr = 'X-Token '.concat(this.props.location.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.baseURL,
    headers: {         
        'Authorization': AuthStr
    },
   });
   // Authentication using Auth Code - AON End
    this.setState({ loading: true });
    // const URL = axios.defaults.baseURL + '/PayeePortal/LoadRecentPayments?wireID=' + params;
    const URL = '/PayeePortal/LoadRecentPayments?wireID=' + params;
    authAxios.get(URL)
      .then(response => {
        if(response.data.mainCoreRes !=undefined && response.data.mainCoreRes.userMessage == "Expired Token")
        {
            this.props.history.push('/Timeout');
        }
        else{
        this.setState({ paymentData: response.data.dt });
        this.setState({ showModal: true })
        this.setState({ loading: false });
        }
      })
      .catch(error => {
        console.log(error)
        this.setState({ errorMsg: 'Some error occured, Please try again later.' })
        this.setState({ loading: false });
      })
    this.setState({ loading: false });
  }

  componentDidMount() {
    debugger;
   
    this.setState({ requestID: this.props.location.state.requestID });
    this.setState({ payeeName: this.props.location.state.payeeName });
    this.setState({ entityName: this.props.location.state.entityName });
    this.setState({ clientID: this.props.location.state.clientID });
    this.setState({ payeeEmail: this.props.location.state.payeeEmail });
    
    

     // Authentication using Auth Code - AON Start
   const AuthStr = 'X-Token '.concat(this.props.location.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.baseURL,
    headers: {         
        'Authorization': AuthStr
    },
   });
   // Authentication using Auth Code - AON End

    const URL='/PayeePortal/GetDashboardDetails'  
    authAxios.get(URL)      
      .then(response => {
        debugger;
        if(response.data.mainCoreRes !=undefined && response.data.mainCoreRes.userMessage == "Expired Token")
        {
          this.props.history.push('/Timeout');
        }
        else{
        
          this.setState({ manageaccounts: response.data.ds.Table })
          this.setState({ manageaccountsForApproval: response.data.ds.wire })
         
          this.setState({ loading: false });    
         }
      })
      .catch(error => {
        console.log(error)
        this.setState({ errorMsg: 'Some error occured, Please try again later.' })
      })
  }

  render() {
    debugger;
    const { manageaccounts, manageaccountsForApproval, errorMsg } = this.state
    let dataBank = this.state.paymentData;

    const data = {
      columns: [
        {
          label: 'ID',
          field: 'TransactionID',
          width: 50
        },
        {
          label: 'Ref',
          field: 'PaymentReference',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Amount',
          field: 'PaymentAmount',
          sort: 'asc',
          width: 270
        },
        {
          label: 'Currency',
          field: 'Summary',
          sort: 'asc',
          width: 200
        },
        {
          label: 'Status',
          field: 'Status',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Date Initiated',
          field: 'Initiated',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Date Approved',
          field: 'Approved',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Date Released',
          field: 'Released',
          sort: 'asc',
          width: 100
        }
      ],
      rows: dataBank
    };

    const MyModel = (props) => (<Modal show={props.isHidden} onHide={props.onClose} size="lg" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title>Recent Payments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MDBDataTable
          striped
          bordered
          hover
          data={data}
        />
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={props.onClose}>Close</Button> */}
      </Modal.Footer>
    </Modal>);
    return (
      <div>
      
        <Header requestID={this.state.requestID} clientID={this.state.clientID} payeeEmail={this.state.payeeEmail} entityName={this.state.entityName} payeeName={this.state.payeeName} />
        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">

            <div class="content-wrapper">
              <div class="col-md-12 stretch-card">
                <div class="card-body">
                  <ul class="nav nav-pills1 nav-pills-success1" id="pills-tab" role="tablist">
                    <li class="nav-item1">
                      <a class="nav-link1 active" id="pills-new-tab" data-toggle="pill" href="#pills-new" role="tab" aria-controls="pills-new" aria-selected="true">New Requests</a>
                    </li>
                    <li class="nav-item1">
                      <a class="nav-link1" id="pills-pending-tab" data-toggle="pill" href="#pills-pending" role="tab" aria-controls="pills-pending" aria-selected="false">Pending Approval</a>
                    </li>
                    <li class="nav-item1">
                      <a class="nav-link1" id="pills-approved-tab" data-toggle="pill" href="#pills-approved" role="tab" aria-controls="pills-approved" aria-selected="false">Approved</a>
                    </li>
                  </ul>




                  <div class="tab-content" id="pills-tabContent">




                    <div class="tab-pane fade show active" id="pills-new" role="tabpanel" aria-labelledby="pills-new-tab">

                      <div class="d-sm-flex justify-content-between align-items-center my-3">
                        <h3 class=" font-weight-medium text-black">New Requests</h3>
                      </div>
                      <div class="row">

                        {

                          manageaccounts === undefined ? '' :
                            manageaccounts.map(account =>
                              account.Status == '' ?
                                <div class="col-md-6 grid-margin grid-margin stretch-card">
                                  <div class="card" style={{ border: "3px #3eba8c dotted", textDecoration: "none" }}>
                                    <div class="card-body text-center">
                                      <div style={{ marginBottom: "10px" }}>
                                        <h6 class="text-black"><b>{account.PayeeName}</b> </h6>
                                        <p class="text-muted mb-0">{account.PayeeCurrency} (<i className={"mdi mdi-currency-" + account.currencysymbol}></i>)</p>
                                      </div>
                                      <div class="border-top pt-3">
                                        <div style={{ marginTop: "20px" }}>
                                          <Link id={account.RequestIDEncrpted + ' - ' + account.PISessionID + ' - ' + account.ClientID + ' - ' + account.PayeeName + ' - ' + account.PayeeCurrency + ' - ' + account.PayeeEmail} to={{
                                            pathname: '/Managebankaccount',
                                            state: {
                                              sessionID: account.PISessionID,
                                              requestID: this.state.requestID,
                                              entityID: account.ClientID,
                                              payeeName: account.PayeeName,
                                              currency: account.PayeeCurrency,
                                              payeeEmail: account.PayeeEmail,
                                              countryCode: account.PayeeCountry,
                                              nickname: account.Nickname,
                                              entityName: this.state.entityName,
                                            }
                                          }}><p style={{ marginTop: "20px", fontSize: "20px", color: "#ccc" }}><i class="mdi mdi-plus-box" style={{ fontSize: "40px" }}></i><br />Add Bank Account</p></Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                : ''
                            )
                        }
                        {errorMsg ? <div className="col-md-12 grid-margin grid-margin stretch-card" style={{ color: "red" }}>{errorMsg}</div> : null}
                      </div>
                    </div>

                    <div class="tab-pane fade" id="pills-pending" role="tabpanel" aria-labelledby="pills-pending-tab">

                      <div class="d-sm-flex justify-content-between align-items-center my-3">
                        <h3 class=" font-weight-medium text-black">Pending Approval</h3>
                      </div>

                      <div class="row">
                        {

                          manageaccountsForApproval === undefined ? '' :

                            manageaccountsForApproval.map(accountWire =>

                              accountWire.Status == 'pending' ?

                                <div class="col-md-6 grid-margin grid-margin stretch-card" id={accountWire.ID}>
                                  <div class="card">

                                    <div class="card-body text-center" style={{ color: "#3a3a3a", cursor: "pointer;" }}>
                                      <div>
                                        {/* <div class="font-weight-light" style={{ float: "left", color: "#0073ae", marginTop: "-15px", marginLeft: "-20px" }}><div class="badge badge-pill badge-warning">1</div> <div class="badge badge-pill badge-success">2</div></div> */}
                                        <h6 class="text-black">{accountWire.BENEFICIARY_NAME}</h6>
                                        <p class="text-muted mb-0">{accountWire.CURRENCY_NAME}</p>
                                      </div>
                                      <p class="mt-2 card-text">
                                        {accountWire.BENEFICIARY_ADDRESS}
                                      </p>
                                      <div class="border-top pt-3">
                                        <div class="row">
                                          <div class="col-4">
                                            <h6>AC#: {accountWire.BENEFICIARY_ACCOUNTCODE}</h6>
                                            <p>Date : {accountWire.CREATED_ON}</p>
                                          </div>
                                          <div class="col-4" style={{ borderLeft: "2px solid #2caae1;" }}>
                                            <h6>{accountWire.BENEFICIARYBANK_NAME}</h6>
                                            <p>{accountWire.Bank_Country}</p>
                                          </div>
                                          <div class="col-4" style={{ borderLeft: "2px solid #2caae1;" }}>
                                            {/* <h6 class="text-green">Approved <i class="mdi mdi-check-circle-outline" style={{ fontSize: "18px", fontWeight: "700;" }} title="Approved"></i></h6> */}
                                            <h6 class="text-youtube">Pending <i class="mdi mdi-cancel" style={{ fontSize: "18px; font-weight: 700;" }} title="Pending"></i></h6>
                                            <p>Updated : {accountWire.UPDATED_ON}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>

                                : ''
                            )
                        }
                        {errorMsg ? <div className="col-md-12 grid-margin grid-margin stretch-card" style={{ color: "red" }}>{errorMsg}</div> : null}


                      </div>


                    </div>

                    <div class="tab-pane fade" id="pills-approved" role="tabpanel" aria-labelledby="pills-approved-tab">
                      <div class="d-sm-flex justify-content-between align-items-center my-3">
                        <h3 class=" font-weight-medium text-black">Approved Accounts</h3>                        
                      </div>

                      <div class="row">

                        {

                          manageaccountsForApproval === undefined ? '' :

                            manageaccountsForApproval.map(accountWire =>

                              accountWire.Status == 'Approved' ?
                                <div class="col-md-6 grid-margin grid-margin stretch-card" style={{ color: "#3a3a3a", cursor: "pointer;" }} id={accountWire.ID} onClick={() => { this.LoadRecentPayments(accountWire.ID) }} >
                                  <div class="card" >
                                  
                                    <div class="card-body" style={{ color: "#3a3a3a", cursor: "pointer;" }}>    
                                                                   
                                      <div>
                                      
                                        {/* <div class="font-weight-light" style={{ float: "left", color: "#0073ae", marginTop: "-15px", marginLeft: "-20px" }}><div class="badge badge-pill badge-warning">1</div> <div class="badge badge-pill badge-success">2</div></div> */}
                                        <h6 class="mt-2 text-green"  style={{ float: ""}}>Recent Payments</h6> 
                                        <h6 class="text-black text-center">{accountWire.BENEFICIARY_NAME}</h6>
                                        <p class="text-muted text-center mb-0">{accountWire.CURRENCY_NAME}</p>
                                      </div>
                                     
                                      <p class="mt-2 card-text text-center">{accountWire.BENEFICIARY_ADDRESS}</p>
                                                                               
                                      
                                      
                                      <div class="border-top pt-3">
                                        <div class="row">
                                          <div class="col-4">
                                            <h6>AC#: {accountWire.BENEFICIARY_ACCOUNTCODE}</h6>
                                            <p>Date : {accountWire.CREATED_ON}</p>
                                          </div>
                                          <div class="col-4" style={{ borderLeft: "2px solid #2caae1;" }}>
                                            <h6>{accountWire.BENEFICIARYBANK_NAME}</h6>
                                            <p>{accountWire.Bank_Country}</p>
                                          </div>
                                          <div class="col-4" style={{ borderLeft: "2px solid #2caae1;" }}>
                                            <h6 class="text-green">Approved <i class="mdi mdi-check-circle-outline" style={{ fontSize: "18px", fontWeight: "700;" }} title="Approved"></i></h6>
                                            {/* <h6 class="text-youtube">Pending <i class="mdi mdi-cancel" style={{fontSize: "18px; font-weight: 700;"}} title="Pending"></i></h6> */}
                                            <p>Updated : {accountWire.UPDATED_ON}</p>
                                          </div>
                                        </div>
                                      </div>                                      
                                    </div>
                                  </div>
                                </div>
                                : ''
                            )
                        }

                        {errorMsg ? <div className="col-md-12 grid-margin grid-margin stretch-card" style={{ color: "red" }}>{errorMsg}</div> : null}



                      </div>


                    </div>

                  </div></div>
              </div>
            </div>



          </div>
        </div>

        {this.state.loading === true ? <div class="overlay"> </div> : ''}
        <BallClipRotate color={'#123abc'} loading={this.state.loading} />
        <div>
          <MyModel isHidden={this.state.showModal} onClose={this.hideModal} />
        </div>
     

        <Footer />
      </div>
    )
  }
}

export default Dashboard
